import { HeidiVersion } from '@heidi/schema/ml-scribe';

import type { Heidi2WelcomeOutcome } from './heidi-2-explore-later-eligibility';

/**
 * Team admins on Heidi II, after they have been through (or skipped) the
 * welcome. The launch queue still applies device, managed-account, and
 * recording guards.
 */
export const computeShouldShowHeidi2ConfirmAccessModal = ({
  isTeamHeidi2AccessControlsEnabled,
  isTeamAdmin,
  heidiVersion,
  welcomeOutcome,
}: {
  isTeamHeidi2AccessControlsEnabled: boolean;
  isTeamAdmin: boolean;
  heidiVersion: HeidiVersion | null | undefined;
  welcomeOutcome: Heidi2WelcomeOutcome;
}): boolean =>
  isTeamHeidi2AccessControlsEnabled &&
  isTeamAdmin &&
  heidiVersion === HeidiVersion.Value2 &&
  welcomeOutcome !== 'unseen';
